import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import styled from 'styled-components'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'
import { timerAlert } from 'util/util'

import { useSpring, animated, useTransition } from '@react-spring/web'

import NavigateButtonPrun from 'components/NavigationButtonPrun'

import SpeedImg from 'assets/img/speed/speed.png'
import ProductBg from 'assets/img/screenType1/productBgImg.png'

import { apiSaveLog, apiThumbnailList } from 'api/api'

const Container = styled.div`
	background-image: url(${ProductBg});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
`

const HorizontalScroll = styled.ul`
	display: flex;
	justify-content: center;
	overflow-x: scroll;
	overflow-y: hidden;
	white-space: nowrap;
	position: absolute;
	top: 336px;
	left: 0;
	right: 0;
	list-style: none;
	padding: 0;
	margin: 0;
	-webkit-overflow-scrolling: touch;
	&::-webkit-scrollbar {
		display: none;
	}
	&.flexStart {
		justify-content: flex-start;
	}
	li {
		width: 404px;
		height: 526px;
		margin-right: 30px;
		margin-left: 30px;
		button {
			border: 0;
			outline: 0;
			background: transparent;
			width: 386px;
			height: 475px;
		}
	}
`
const HorizontalScrollAfter = styled.div`
	display: block;
	width: 100px;
	height: 475px;
	position: absolute;
	top: 336px;
	right: 0;
	opacity: 0.8;
	background: linear-gradient(
		to right,
		rgba(255, 255, 255, 0) 0%,
		rgba(255, 255, 255, 0.7) 100%
	);
`

const PageTitle = styled.div`
	position: absolute;
	top: 68px;
	left: 58px;
	font-size: 40px;
	color: #565858;
	min-width: 210px;
	text-align: center;
	line-height: 1;
	.bar {
		width: 200px;
		height: 10px;
		background: #eee4d0;
		margin: 15px auto;
	}
	span {
		font-size: 50px;
	}
`

const Trail = () => {
	const location = useLocation()
	const deviceInfo = useSelector(selectDevice)
	const navigate = useNavigate()

	const [productList, setProductList] = useState<any[]>([])

	const menuMove1 = useSpring({
		from: { opacity: 0, x: 100 },
		to: { opacity: 1, x: 0 },
		delay: 0,
	})

	const titleMove = useSpring({
		from: { opacity: 0, y: -100 },
		to: { opacity: 1, y: 0 },
		delay: 0,
	})

	const onTouchEnd = (e: any) => {
		console.log(e)
		console.log(location.state?.item?.subsortId)
		const params = {
			subsortId: location.state?.item?.subsortId,
			productId: e.productId,
			fildId: e.fileId,
			name: e.name,
		}

		const logRequest = {
			userId: deviceInfo.userId,
			kioskDeviceId: deviceInfo.kioskDeviceId,
			categoryId: deviceInfo.categoryId,
			productId: e.productId,
			subSortId: location.state?.item?.subsortId,
		}
		if (
			logRequest.userId &&
			logRequest.kioskDeviceId &&
			logRequest.categoryId &&
			logRequest.productId &&
			logRequest.subSortId
		) {
			apiSaveLog(logRequest)
		}

		navigate(`/prun/trail/view`, {
			state: { item: params },
		})
	}

	useEffect(() => {
		console.log(location.state?.item)
		if (!location.state?.item) {
			timerAlert('잘못된 접근입니다.', 'error', () => navigate('/'))
		}
		const request = {
			subsortId: location.state?.item?.subsortId,
			kioskDeviceId: deviceInfo.kioskDeviceId,
		}
		apiThumbnailList(request).then((res) => {
			console.log(res)
			setProductList(res)
		})
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		document.addEventListener('touchmove', disablePinchZoom, {
			passive: false,
		})
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
	}, [])

	return (
		<Container className="container">
			<PageTitle>
				<animated.div style={titleMove}>
					<b>트레일러닝화</b>
					<div className="bar"></div>
					<span className="asics-bold-italic">TRAIL</span>
				</animated.div>
			</PageTitle>
			{productList.length > 0 ? (
				<animated.div style={menuMove1}>
					<HorizontalScroll
						className={
							productList.filter((item) => item.pdbkProductId === undefined).length > 4
								? 'flexStart'
								: ''
						}
					>
						{productList
							.filter((item) => item.pdbkProductId === undefined)
							.map((item, index) => (
								<li key={index}>
									<button
										type="button"
										onClick={() => onTouchEnd(item)}
									>
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt={item.name}
										/>
									</button>
								</li>
							))}
					</HorizontalScroll>
					{/* <HorizontalScrollAfter /> */}
				</animated.div>
			) : (
				<div className="noData">제품이 없습니다.</div>
			)}
			<NavigateButtonPrun />
		</Container>
	)
}

export default Trail
